var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsEnum, IsNumber, IsObject, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
import { PreventionTrackingType } from '../enum/prevention-tracking-type.js';
import { PreventionCourseModuleSectionFullSizeDto } from './prevention-course-module-section.full-size.dto.js';
export class PreventionSectionTrackingFullSizeDto {
    id;
    createdAt;
    updatedAt;
    preventionCourseModuleSectionId;
    preventionCourseModuleSection;
    user;
    userId;
    type;
    questionMarker;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionSectionTrackingFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionSectionTrackingFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionSectionTrackingFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionSectionTrackingFullSizeDto.prototype, "preventionCourseModuleSectionId", void 0);
__decorate([
    IsObject(),
    Expose(),
    Type(() => PreventionCourseModuleSectionFullSizeDto),
    __metadata("design:type", PreventionCourseModuleSectionFullSizeDto)
], PreventionSectionTrackingFullSizeDto.prototype, "preventionCourseModuleSection", void 0);
__decorate([
    IsObject(),
    Exclude(),
    Type(() => UserProfileDto),
    __metadata("design:type", Function)
], PreventionSectionTrackingFullSizeDto.prototype, "user", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", String)
], PreventionSectionTrackingFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsEnum(PreventionTrackingType),
    Expose(),
    __metadata("design:type", String)
], PreventionSectionTrackingFullSizeDto.prototype, "type", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PreventionSectionTrackingFullSizeDto.prototype, "questionMarker", void 0);
//# sourceMappingURL=prevention-section-tracking.full-size.dto.js.map